import store from '@/store';
import { getAction } from '@/store/modules/actions/getters';
import { getService as getServiceGetter, getServiceActionCollection } from '@/store/modules/apps/getters';
import { editNode as editNodeGetter } from '@/store/modules/selectedNode/getters';

import AppActionService from '@/utils/AppActionService';
import AppService from '@/utils/AppService';

/* Private */
function editNode() {
	const getters = store.getters;

	const result = getters[editNodeGetter.fullPath];
	return result;
}

function getService() {
	const getters = store.getters;

	return getters[getServiceGetter.fullPath]();
}

function skipAuthAction() {
	const action = selectedAction();
	return action && action.skip_auth;
}

/* Public */

function selectedAction() {
	const getters = store.getters;

	return getters[getAction.fullPath](editNode().action);
}

function selectedApp(selectedServiceActionCollectionId) {
	const getters = store.getters;

	if (selectedServiceActionCollectionId || AppActionService.doesActionHasServiceActionCollection(selectedAction())) {
		const serviceActionCollectionId =
			selectedServiceActionCollectionId || AppActionService.getActionServiceActionCollection(selectedAction());
		return getters[getServiceActionCollection.fullPath](serviceActionCollectionId);
	}
	return getService(editNode().service);
}

function originalActionApp() {
	return getService(editNode().service);
}

function isProfileSelectionNeeded() {
	return AppService.doesRequiresAuth(originalActionApp()) && !skipAuthAction();
}

function stepHeaderIcon() {
	const action = selectedAction();
	const app = selectedApp(this.selectedServiceActionCollectionId);
	const originalApp = originalActionApp();
	return AppActionService.getActionIcon({ action, app, originalApp });
}

const BlockEditorBridge = {
	selectedAction,
	selectedApp,
	originalActionApp,
	isProfileSelectionNeeded,
	stepHeaderIcon,
};

export default BlockEditorBridge;
